import ru from "./ru";
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const en = {
  // Common
  common: {
    appName: appName,
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    search: 'Search',
    noResults: 'No results found',
    error: 'An error occurred',
    success: 'Success',
  },

  // Header
  header: {
    searchPlaceholder: 'Search news, topics, hashtags...',
    searchPlaceholderMobile: 'Search...',
    home: 'Home',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Model',
    upload: 'Upload',
    notifications: 'Notifications',
    login: 'Sign in',
    register: 'Sign up',
  },

  // Footer
  footer: {
    tagline: `The best platform to share Coser, Hotgirl, and Model photos on ${appName}.`,
    copyright: `© {year} ${appName}. All rights reserved.`,
    sections: {
      explore: 'Explore',
      account: 'Account',
      support: 'Support',
    },
    links: {
      home: 'Home',
      hotgirl: 'Hotgirl',
      coser: 'Coser',
      model: 'Model',
      aoDai: 'Ao Dai',
      login: 'Sign In',
      register: 'Sign Up',
      upload: 'Upload Photo',
      dashboard: 'Dashboard',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      report: 'Report Violation',
      contact: 'Contact Us',
    },
  },

  collections: {
    title: 'Collections',
    createAlbum: 'Create Album',
    saved: 'Saved',
    noSaved: 'No saved photos yet',
    noSavedHint: 'Explore photos now →',
    removedSave: 'Unsaved',
    createModalTitle: 'Create new album',
    albumNamePlaceholder: 'Album name...',
    cancel: 'Cancel',
    create: 'Create',
    albumCreated: 'Album created',
  },

  // Home page
  home: {
    title: 'Discover',
    titleHighlight: 'beauty',
    titleSuffix: 'of life',
    subtitle: 'Thousands of Coser, Hotgirl, and Model photos updated every day',
    sortNewest: 'Newest',
    sortTrending: 'Trending',
    sortPopular: 'Popular',
    allCategories: 'All',
    noMorePosts: 'You have seen all photos',
  },

  // Auth
  auth: {
    login: {
      title: 'Sign in to continue',
      continueWithGoogle: 'Continue with Google',
      orLoginWithEmail: 'or sign in with email',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      submitButton: 'Sign In',
      loading: 'Signing in...',
      noAccount: "Don't have an account?",
      registerLink: 'Sign up now',
      errorCredentials: 'Incorrect email or password',
      successLogin: 'Signed in successfully!',
    },
    register: {
      title: 'Create a free account',
      displayName: 'Display Name',
      displayNamePlaceholder: 'John Doe',
      email: 'Email',
      password: 'Password',
      passwordPlaceholder: 'At least 8 characters',
      confirmPassword: 'Confirm Password',
      submitButton: 'Sign Up',
      loading: 'Creating account...',
      hasAccount: 'Already have an account?',
      loginLink: 'Sign in',
      errorPasswordMismatch: 'Passwords do not match',
      errorPasswordLength: 'Password must be at least 8 characters',
      errorGeneric: 'Registration failed',
      successRegister: 'Account created successfully!',
      emailTaken: 'Email already in use',
      serverError: 'Server error, please try again later',
    },
    forgotPassword: {
      title: 'Forgot password',
      subtitle: 'Enter your email and we will send a reset link',
      email: 'Email',
      submitButton: 'Send Reset Link',
      backToLogin: 'Back to sign in',
      sending: 'Sending...',
      emailSent: 'Email sent!',
      checkEmail: 'Check the inbox of {email} for the password reset link.',
      instructions: 'Enter your email and we will send a link to reset your password.',
    },
  },

  // User menu
  userMenu: {
    dashboard: 'Dashboard',
    collections: 'Collections',
    settings: 'Settings',
    logout: 'Sign Out',
  },

  // Settings
  settings: {
    title: 'Account Settings',
    profile: {
      nav: 'Profile',
      title: 'Profile Information',
      displayName: 'Display Name',
      username: 'Username',
      website: 'Website',
      bio: 'Bio',
      bioPlaceholder: 'Introduce yourself...',
      changeAvatar: 'Change Avatar',
      avatarHint: 'JPG, PNG, WebP max 5MB',
      saveButton: 'Save Changes',
      saving: 'Saving...',
      savedSuccess: 'Changes saved',
    },
    password: { 
      nav: 'Password',
      title: 'Change Password',
      fields: {
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirm: 'Confirm New Password',
      },
      errors: {
        confirm: 'New Passwords do not match',
        minLength: 'Password must be at least 8 characters',
      },
      success: 'Password changed successfully!',
      saving: 'Saving...',
      submit: 'Change Password',
    },
    notifications: { 
      nav: 'Notifications',
      title: 'Notification Settings',
      options: {
        likes: 'When someone likes your photo',
        comments: 'When someone comments',
        replies: 'When someone replies to your comment',
        follows: 'When someone follows you',
        approved: 'When the post is approved',
        email_digest: 'Weekly email summary',
        marketing: 'Promotional and event notifications',
      },
      saveSuccess: 'Notification settings saved',
      saving: 'Saving...',
      saveButton: 'Save Settings',
    },
    security: { 
      nav: 'Security',
      twoFactorAuth: 'Two-Factor Authentication (2FA)',
      twoFactorAuthHint: 'Enhance security with a verification code from the app',
      comingSoon: 'Coming Soon',
      activeSessions: 'Active Sessions',
      currentBrowser: 'Current Browser',
      lastLogin: 'Last Login',
      active: 'Active',
      dangerZone: 'Danger Zone',
      deleteAccountHint: 'Deleting your account will permanently remove all your data.',
      deleteAccount: 'Delete Account',
    },
  },

  // Post detail
  post: {
    likes: '{count} likes',
    views: '{count} views',
    shares: '{count} shares',
    comments: '{count} comments',
    save: 'Save',
    saved: 'Saved',
    share: 'Share',
    linkCopied: 'Link copied!',
    follow: 'Follow',
    following: 'Following',
    relatedPosts: 'Related Posts',
    commentPlaceholder: 'Write a comment...',
    commentLoginPlaceholder: 'Sign in to comment...',
    commentSubmit: 'Post',
    commentSubmitting: 'Posting...',
    noComments: 'No comments yet. Be the first!',
    savedToCollection: 'Saved to collection',
    removedFromCollection: 'Removed from collection',
    description: 'Description',
    profileView: 'View profile',
    replies: 'Replies',
    unsaved: 'Removed from saved',
    liked: 'Liked',
    like: 'Like',
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    empty: 'No notifications',
    markAllRead: 'Mark all as read',
    types: {
      like_post: 'liked your photo',
      comment: 'commented on your photo',
      reply: 'replied to your comment',
      follow: 'followed you',
      approve: 'your post was approved',
      reject: 'your post was rejected',
      system: 'system notification',
    },
  },

  // Search
  search: {
    title: 'Search results for',
    result: 'Results',
    tryOtherKeywords: 'Try other keywords...',
    noResults: 'No results found for',
    placeholder: 'Search...',
    thisHashtag: 'photos with this hashtag',
    results: 'results',
  },

  // Upload
  upload: {
    title: 'Upload Photo',
    dragDrop: 'Drag & drop or click to select',
    supportedFormats: 'Supports JPG, PNG, WebP, GIF',
    submit: 'Publish',
    submitting: 'Publishing...',
    titleField: 'Title',
    cover: 'Cover',
    titlePlaceholder: 'Enter an attractive title...',
    descriptionField: 'Description',
    descriptionPlaceholder: 'Detailed description of the photo set...',
    hashtagsField: 'Hashtags',
    statusField: 'Status',
    statusPublic: 'Public',
    statusPrivate: 'Private',
    statusDraft: 'Draft',
    error: 'Error uploading',
    errorSelect: 'Select at least 1 photo',
    errorTitle: 'Enter a title',
    photos: 'photos',
    uploading: 'Uploading...',
  },

  // Not found
  notFound: {
    title: 'Page not found',
    subtitle: 'The page you are looking for does not exist.',
    backHome: 'Back to Home',
  },

  liked: {
    title: 'Liked Posts',
    empty: 'You have not liked any posts yet.',
  },
  user: {
    unknown: 'Unknown',
  },
  globalError: {
    title: 'An error occurred',
    subtitle: 'Sorry for the inconvenience. Please try again.',
    retry: 'Retry',
  },
  username: {
    posts: 'Posts',
    likes: 'Likes',
    followers: 'Followers',
    following: 'Following',
    editProfile: 'Edit Profile',
    message: 'Message',
    noPosts: 'No posts yet.',
    bio: 'View photos of ',
    notFound: 'User not found',
  },
  topic: {
    notFound: 'Topic not found',
    viewTitle: 'View topic ',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Hello',
    stats: {
      posts: 'Posts',
      views: 'Views',
      likes: 'Likes',
      comments: 'Comments',
    },
  },
  adsblock: {
    title: "You are using AdBlock",
    description: "Please disable AdBlock to view high-quality images and help us keep the website free.",
    action: "I have disabled it — Reload",
    cancel: "Skip"
  },
  pwa: {
    title: `Install ${appName} for a better experience!`,
    iosSubtitle: 'Press Share → Add to Home Screen',
    androidSubtitle: 'Get notified about new photo sets as soon as they are released',
    installButton: 'Install',
    disclaimer: 'Quick installation, no app store required.',
  },
  autotrans: {
    title: 'Automatically Translated',
    translated: 'Translation',
    origin: 'Original Content',
  },
  subscription: {
    title: 'Subscribe to Notifications',
    description: 'Get notified about new photo sets as soon as they are released.',
    subscribeButton: 'Subscribe',
    unsubscribeButton: 'Unsubscribe',
    subscribed: 'You are subscribed to notifications.',
    unsubscribed: 'You have unsubscribed from notifications.',
    error: 'An error occurred while updating your subscription. Please try again.',
    success_tit: '🎉 Notifications Enabled!',
    denied_tit: 'Notifications Denied',
    error_tit: 'An Error Occurred',
    success_des: 'You will receive notifications when new content is available.',
    denied_des: 'You can re-enable them in your browser settings.',
    error_des: 'Please try again later.',
    skip: 'Skip',
    processing: 'Processing...',
    noti: 'Enable Notifications',
    rule: 'Only show notifications for new content.',
    notify_title: `Notifications - ${appName}`,
    notify_body: "The new gallery has been released. Check it out now!",
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'We would love to hear from you! Please fill out the form below and we will get back to you as soon as possible.',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
    submitButton: 'Send Message',
    sending: 'Sending...',
    successTitle: 'Message Sent!',
    successMessage: 'Thank you for reaching out. We will get back to you shortly.',
    errorTitle: 'An error occurred',
    errorMessage: 'There was an error sending your message. Please try again later.',
    res_time_title: 'Response time',
    res_time: 'We typically respond within 1–3 business days.',
    report_content: 'Report Content',
    report_content_hint: ' To report a post or user, use the report button directly on the content or select &ldquo;Report content&rdquo; above.',
    value_default: 'Select a topic',
    value_general: 'General inquiry',
    value_report: 'Report content',
    value_account: 'Account issue',
    value_business: 'Business / partnership',
    value_feedback: 'Feedback & suggestions',
    value_other: 'Other'
  },
  // Language switcher
  language: {
    label: 'Language',
    en: 'English',
    vi: 'Tiếng Việt',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    fr: 'Français',
    es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
} as const;

export default en;
type Widen<T> = T extends string ? string : { -readonly [K in keyof T]: Widen<T[K]> };
export type Translations = Widen<typeof en>;
